import React from 'react';

export function BoxClose() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g stroke="#1E3D5A" transform="translate(1 1)">
          <g>
            <path d="M0 0H29V29H0z"></path>
          </g>
          <path d="M8 21L21 8"></path>
          <path d="M8 21L21 8" transform="matrix(-1 0 0 1 29 0)"></path>
        </g>
      </g>
    </svg>
  );
}
